export enum ReportType {
  EX_DASHBOARD = 'ex_dashboard',
  EX_REPORTS = 'ex_reports',
  FORESIGHT = 'foresight',
  INSIGHT = 'insight',
  STANDART = 'standart',
  ATA_DASHBOARD = 'ata_dashboard',
  INNER_LOOP = 'inner_loop',
}
